"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCallOrEmailState = void 0;
exports.defaultCallOrEmailState = {
    callText: '2102 0888',
    emailText: 'support@okay.com',
};
